import { BaseSurvey } from '../base-survey';
import { AssetLibraryAppSurveyView } from './view';
import { validateAssetLibraryTriggerCondition } from '../utils';

export class AssetLibraryAppSurvey extends BaseSurvey {
  getSurveyName = () => 'AssetLibraryAppSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? 'b4db6685-adec-4ecf-a7d5-288eaccb13f1' : '958137e5-13be-4f08-8a07-0afe1974cbff');

  validateTriggerCondition = () => validateAssetLibraryTriggerCondition(this, 'AssetLibraryAppSurveyTrigger');

  onSurveySubmit() {
    window.survey.AssetLibraryAppSurveyTrigger = false;

    super.onSurveySubmit();
  }

  onSurveyDismiss() {
    window.survey.AssetLibraryAppSurveyTrigger = false;

    super.onSurveyDismiss();
  }

  getSurveyComponent = () => AssetLibraryAppSurveyView;
}
